import React from "react";
import styles from "./aero.module.css";
import { MdOutlineArrowOutward } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const AeroplaneSection = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      {/* -------------aeroplane-section-start------------- */}
      <div className={styles.aeroplane_section}>
        <div className={styles.child_section}>
          <h6>Let’s Build Something Extraordinary Together</h6>
          <p>
            Whether you’re looking to source high-quality commodities, explore
            innovative solutions, or partner on impactful projects, we’re here
            to help. Connect with us today and take the first step toward
            achieving your goals.
          </p>
          <button onClick={() => navigate(`/contact`)}>
            Partner with us today <MdOutlineArrowOutward className="mt-1" />
          </button>
        </div>

        <div className={styles.ap_section}>
          <img src="/images/landingPageImages/aeroplane.png" alt="aeroplane" />
        </div>
      </div>
      {/* -------------aeroplane-section-end------------- */}
    </React.Fragment>
  );
};

export default AeroplaneSection;
